import { useEffect, useState } from "react";
import { maskTelefone } from "shared/utils/masks";
import styles from "./ModalEditarCampo.module.scss";

interface Props {
  open: boolean;
  titulo: string;
  tipo: "nome" | "email" | "telefone" | "data";
  valorAtual: string;
  loading?: boolean;
  onClose: () => void;
  onSave: (valor: string) => Promise<void>;
}

export const ModalEditarCampo: React.FC<Props> = ({
  open,
  titulo,
  tipo,
  valorAtual,
  loading = false,
  onClose,
  onSave,
}) => {
  const [valor, setValor] = useState("");

  useEffect(() => {
    if (open) {
      setValor(valorAtual ?? "");
    }
  }, [open, valorAtual]);

  if (!open) return null;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const novoValor = e.target.value;

    if (tipo === "telefone") {
      setValor(maskTelefone(novoValor));
      return;
    }

    setValor(novoValor);
  };

  const handleSalvar = async () => {
    const valorLimpo = tipo === "telefone" ? valor.replace(/\D/g, "") : valor.trim();

    if (!valorLimpo) return;

    await onSave(valorLimpo);
  };

  const inputType = tipo === "email" ? "email" : tipo === "data" ? "date" : "text";

  const placeholder =
    tipo === "nome"
      ? "Digite seu nome"
      : tipo === "email"
        ? "Digite seu e-mail"
        : tipo === "telefone"
          ? "Digite seu telefone"
          : "";

  const label =
    tipo === "nome"
      ? "Nome"
      : tipo === "email"
        ? "E-mail"
        : tipo === "telefone"
          ? "Telefone"
          : "Data de Nascimento";

  return (
    <div className={styles.overlay} onClick={() => !loading && onClose()}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h2>{titulo}</h2>

        <div className={styles.field}>
          <label>{label}</label>

          <input
            type={inputType}
            value={valor}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={loading}
            autoFocus
          />
        </div>

        <div className={styles.actions}>
          <button type="button" className={styles.cancelar} onClick={onClose} disabled={loading}>
            Cancelar
          </button>

          <button
            type="button"
            className={styles.salvar}
            onClick={handleSalvar}
            disabled={loading || !valor.trim()}
          >
            {loading ? "Salvando..." : "Salvar"}
          </button>
        </div>
      </div>
    </div>
  );
};